<template>
	<div class="box">
		<div class="left_box">
			<el-tabs>
				<el-tab-pane>
					<span slot="label"><i class="el-icon-document-remove"></i> 页面管理</span>
					<el-scrollbar class="yemianlie">
						<!-- <div class="tianjiafenzu">
							<i class="el-icon-circle-plus-outline"></i>
							<i class="el-icon-folder-opened"></i>添加分组
						</div> -->
						<div v-for="(l,i) in lie" class="fenzus" @click="Yemian(l)" style="position: relative;" v-if="yeming">{{l.biaoti}} 
						<div class="tianjiazuhe_Shanchu2" @click.stop="Shanchu2(i,l.id)"><i class="el-icon-circle-close"></i></div>
						</div>
							
											
					</el-scrollbar>
					<div class="tijiayemian">
						<el-input placeholder="新增页面名称" v-model="xinzengyemian_ming" class="input-with-select">
							<el-button slot="append" @click="Xinzengyemian">新增</el-button>
						</el-input>
					</div>
				</el-tab-pane>
				<el-tab-pane>
					<span slot="label"><i class="el-icon-menu"></i> 组件库</span>
					<el-scrollbar class="zujian_top">
						<draggable class="zujian_ul" element="div" :value="zujian" :move="onMove" @end="leftEnd" :options="dragOptions1">
							<div v-for="(l,i) in zujian" :key="i">
								<p :class="l.tu" class="Tubiao"></p>
								<p>{{l.ming}}</p>
							</div>
						</draggable>
					</el-scrollbar>
					<!-- <div class="zujian_xia">
						<el-tabs>
							<el-tab-pane label="首页模板" name="first">							
								<el-scrollbar class="zujian_top">
									<draggable class="zujian_ul" element="div" :value="zujian2" :move="onMove" @end="leftEnd" :options="dragOptions1">
										<div v-for="(l,i) in zujian2" :key="i">
											<p :class="l.tu" class="Tubiao"></p>
											<p>{{l.name}}</p>
										</div>
									</draggable>
								</el-scrollbar>
							</el-tab-pane>
							<el-tab-pane label="个人中心" name="second">
								<el-scrollbar class="zujian_top">
									<draggable class="zujian_ul" element="div" :value="zujian3" :move="onMove" @end="leftEnd" :options="dragOptions1">
										<div v-for="(l,i) in zujian3" :key="i">
											<p :class="l.tu" class="Tubiao"></p>
											<p>{{l.name}}</p>
										</div>
									</draggable>
								</el-scrollbar>			
							
							</el-tab-pane>
							<el-tab-pane label="营销插件" name="third">
								<el-scrollbar class="zujian_top">
									<draggable class="zujian_ul" element="div" :value="zujian4" :move="onMove" @end="leftEnd" :options="dragOptions1">
										<div v-for="(l,i) in zujian4" :key="i">
											<p :class="l.tu" class="Tubiao"></p>
											<p>{{l.name}}</p>
										</div>
									</draggable>
								</el-scrollbar>							
							</el-tab-pane>							
						</el-tabs>
					</div> -->
				</el-tab-pane>
			</el-tabs>
		</div>
		<div class="neirong_box">
			<div class="neirong_tou">
				<div class="liangchi">
					<i class="tb-tubiao-"></i>量尺<i class="tb-lower-triangle"></i>
					<div class="jiajian"><span class="el-icon-minus"></span>100%<span class="el-icon-plus"></span></div>
				</div>
				<div class="ye_ming">店铺装修</div>
				<el-button class="houytaianniu" @click="$houtui()">返回后台</el-button>
			</div>
			<el-scrollbar class="neirong_shouji">			
				<div class="shouji_box">
					<!-- <div class="anniu_zuo">
						<div class="anniu zuoshang">
							<el-button icon="tb-qianjin" circle size="small" type="info"></el-button>
							<span class="qianjin">前进</span>
						</div>
						<div class="anniu zuoxia">
							<el-button icon="tb-houtui" circle size="small" type="info"></el-button>
							<span class="houtui">后退</span>
						</div>
					</div> -->
					<div class="neirong_shoujiqu">
						<div class="shouji_tou">
							<div class="el-icon-arrow-left"></div>
							<div class="tou_biaoti">{{yemian_shu.biaoti}}</div>
							<div class="tou_rigth">
								<i class="el-icon-more tu"></i>
								<el-divider direction="vertical" class="tu"></el-divider><i class="el-icon-bangzhu tu"></i>
							</div>
						</div>
						<!-- 自定义 -->
						<el-scrollbar class="zidingyi_hezi">
							<draggable element="div" v-model="shu" :move="onMove" :options="dragOptions2">
								<div class="tianjiazuhe" v-for="(l,i) in shu" @click="Bianji(l,i)">
									<div class="tianjiazuhe_Shanchu" @click.stop="Shanchu(i)"><i class="el-icon-circle-close"></i></div>
									<wenzi v-if="l.leixing=='Wenzi'" :shu="l"></wenzi>
									<Tu v-else-if="l.leixing=='Tu'" :shu="l"></Tu>
									<Anniu v-else-if="l.leixing=='Anniu'" :shu="l"></Anniu>
									<Biaoti v-else-if="l.leixing=='Biaoti'" :shu="l"></Biaoti>
									<Liebiao v-else-if="l.leixing=='Liebiao'" :shu="l"></Liebiao>
									<Shipin v-else-if="l.leixing=='Shipin'" :shu="l"></Shipin>
									<Lunkuo v-else-if="l.leixing=='Lunkuo'" :shu="l"></Lunkuo>
									<Gonggao v-else-if="l.leixing=='Gonggao'" :shu="l"></Gonggao>
									<Zuhe v-else-if="l.leixing=='Zuhe'" :shu="l"></Zuhe>
									<Lunbo v-else-if="l.leixing=='Lunbo'" :shu="l"></Lunbo>
									<Fenlei v-else-if="l.leixing=='Fenlei'" :shu="l"></Fenlei>
									<Shangpin v-else-if="l.leixing=='Shangpin'" :shu="l" ></Shangpin>
									<Sousuo v-else-if="l.leixing=='Sousuo'" :shu="l"></Sousuo>
									<Dingdan v-else-if="l.leixing=='Dingdan'" :shu="l"></Dingdan>
									<Fuwulie v-else-if="l.leixing=='Fuwulie'" :shu="l"></Fuwulie>
									<Zijin v-else-if="l.leixing=='Zijin'" :shu="l"></Zijin>
									<Qiehuandianpu v-else-if="l.leixing=='Qiehuandianpu'" :shu="l"></Qiehuandianpu>
									<Gerenzhongxin v-else-if="l.leixing=='Gerenzhongxin'" :shu="l"></Gerenzhongxin>
									<Jianzhi  v-else-if="l.leixing=='Jianzhi'" :shu="l"></Jianzhi>
									<Shangjiatuijie v-else-if="l.leixing=='Shangjiatuijie'" :shu="l"></Shangjiatuijie>
									<Miaosha v-else-if="l.leixing=='Miaosha'" :shu="l"></Miaosha>
									<Shangpitu v-else-if="l.leixing=='Shangpitu'" :shu="l"></Shangpitu>
									
								</div>
							</draggable>
						</el-scrollbar>
						<!-- 自定义 -->
					</div>
					<!-- <div class="anniu_you">
						<div class="anniu zuoshang">
							<el-button icon="tb-iconfontmoban" circle size="small" type="info"></el-button>
							<span class="shoujiyou_tu">模板</span>
						</div>
						<div class="anniu zuoxia">
							<el-button icon="tb-yuansu" circle size="small" type="info"></el-button>
							<span class="shoujiyou_tu">元素</span>
						</div>
						<div class="anniu youxia">
							<el-button icon="tb-tianjiadaohang" circle size="small" type="info"></el-button>
							<span class="shoujiyou_tu">添加导航</span>
						</div>
					</div> -->
				</div>
			</el-scrollbar>
		</div>
		<div class="right_box">
			<div class="right_tou">
				<!-- <el-button class="small">预览</el-button> -->
				<el-button class="small" @click="Tijiao(0)">保存</el-button>
				<el-button class="small" type="primary" @click="Tijiao(1)">发布</el-button>
			</div>
			<el-scrollbar class="right_neirong">
				<WenziBianji v-if="bianji_shu.leixing=='Wenzi'" v-model="bianji_shu"></WenziBianji>
				<TuBianji v-else-if="bianji_shu.leixing=='Tu'" v-model="bianji_shu"></TuBianji>
				<AnniuBianji v-else-if="bianji_shu.leixing=='Anniu'" v-model="bianji_shu"></AnniuBianji>
				<BiaotiBianji v-else-if="bianji_shu.leixing=='Biaoti'" v-model="bianji_shu"></BiaotiBianji>
				<DingdanBianji v-else-if="bianji_shu.leixing=='Dingdan'" v-model="bianji_shu"></DingdanBianji>
				<FuwulieBianji v-else-if="bianji_shu.leixing=='Fuwulie'" v-model="bianji_shu"></FuwulieBianji>
				<GonggaoBianji v-else-if="bianji_shu.leixing=='Gonggao'" v-model="bianji_shu"></GonggaoBianji>
				<LunboBianji v-else-if="bianji_shu.leixing=='Lunbo'" v-model="bianji_shu"></LunboBianji>
				<FenleiBianji v-else-if="bianji_shu.leixing=='Fenlei'" v-model="bianji_shu"></FenleiBianji>
				<ShangpinBianji v-else-if="bianji_shu.leixing=='Shangpin'" v-model="bianji_shu"></ShangpinBianji>
				<ZijinBianji v-else-if="bianji_shu.leixing=='Zijin'" v-model="bianji_shu"></ZijinBianji>
				<JianzhiBianji v-else-if="bianji_shu.leixing=='Jianzhi'" v-model="bianji_shu"></JianzhiBianji>
				<ShangjiatuijieBianji  v-else-if="bianji_shu.leixing=='Shangjiatuijie'" v-model="bianji_shu"></ShangjiatuijieBianji>
				<!-- 新增页面  取组件名注意不要冲突-->
				<Xinzengyemian v-else-if="bianji_shu.leixing=='Xinzengyemian'" v-model="yemian_shu"></Xinzengyemian>
				<ShipinBianji v-if="bianji_shu.leixing=='Shipin'" v-model="bianji_shu"></ShipinBianji>
				<QiehuandianpuBianji  v-if="bianji_shu.leixing=='Qiehuandianpu'" v-model="bianji_shu"></QiehuandianpuBianji>
				<ShangpituBianji v-if="bianji_shu.leixing=='Shangpitu'" v-model="bianji_shu" ></ShangpituBianji>
				<!-- <LunkuoBianji v-if="bianji_shu.leixing=='Lunkuo'" v-model="bianji_shu"></LunkuoBianji>
				<ZuheBianji v-if="bianji_shu.leixing=='Zuhe'" v-model="bianji_shu"></ZuheBianji>
				<LunboBianji v-if="bianji_shu.leixing=='Lunbo'" v-model="bianji_shu"></LunboBianji>
				<FenleiBianji v-if="bianji_shu.leixing=='Fenlei'" v-model="bianji_shu"></FenleiBianji>
				
				<SousuoBianji v-if="bianji_shu.leixing=='Sousuo'" v-model="bianji_shu"></SousuoBianji>
				<ZijinBianji v-if="bianji_shu.leixing=='Zijin'" v-model="bianji_shu"></ZijinBianji>
				<QiehuandianpuBianji  v-if="bianji_shu.leixing=='Qiehuandianpu'" v-model="bianji_shu"></QiehuandianpuBianji>
				<GerenzhongxinBianji  v-if="bianji_shu.leixing=='Gerenzhongxin'" v-model="bianji_shu"></GerenzhongxinBianji> -->


			</el-scrollbar>
		</div>
	</div>
</template>

<script>
	let that;
	import Shangtu from '../../zujian/Shangtu.vue'
	import Wenzi from '../../zujian/zidingyi/Wenzi.vue'
	import WenziBianji from '../../zujian/zidingyi/WenziBianji.vue'
	import Tu from '../../zujian/zidingyi/Tu.vue'
	import TuBianji from '../../zujian/zidingyi/TuBianji.vue'
	import Anniu from '../../zujian/zidingyi/Anniu.vue'
	import AnniuBianji from '../../zujian/zidingyi/AnniuBianji.vue'
	import Biaoti from '../../zujian/zidingyi/Biaoti.vue'
	import BiaotiBianji from '../../zujian/zidingyi/BiaotiBianji.vue'
	import Liebiao from '../../zujian/zidingyi/Liebiao.vue'
	import LiebiaoBianji from '../../zujian/zidingyi/LiebiaoBianji.vue'
	import Shipin from '../../zujian/zidingyi/Shipin.vue'
	import ShipinBianji from '../../zujian/zidingyi/ShipinBianji.vue'
	import Lunkuo from '../../zujian/zidingyi/Lunkuo.vue'
	import LunkuoBianji from '../../zujian/zidingyi/LunkuoBianji.vue'
	import Gonggao from '../../zujian/zidingyi/Gonggao.vue'
	import GonggaoBianji from '../../zujian/zidingyi/GonggaoBianji.vue'
	import Zuhe from '../../zujian/zidingyi/Zuhe.vue'
	import ZuheBianji from '../../zujian/zidingyi/ZuheBianji.vue'
	import Lunbo from '../../zujian/zidingyi/Lunbo.vue'
	import LunboBianji from '../../zujian/zidingyi/LunboBianji.vue'
	import Fenlei from '../../zujian/zidingyi/Fenlei.vue'
	import FenleiBianji from '../../zujian/zidingyi/FenleiBianji.vue'
	import Shangpin from '../../zujian/zidingyi/Shangpin.vue'
	import ShangpinBianji from '../../zujian/zidingyi/ShangpinBianji.vue'
	import Sousuo from '../../zujian/zidingyi/Sousuo.vue'
	import SousuoBianji from '../../zujian/zidingyi/SousuoBianji.vue'
	import Dingdan from '../../zujian/zidingyi/Dingdan.vue'
	import DingdanBianji from '../../zujian/zidingyi/DingdanBianji.vue'
	import Fuwulie from '../../zujian/zidingyi/Fuwulie.vue'
	import FuwulieBianji from '../../zujian/zidingyi/FuwulieBianji.vue'
	import Zijin from '../../zujian/zidingyi/Zijin.vue'
	import ZijinBianji from '../../zujian/zidingyi/ZijinBianji.vue'
	import Qiehuandianpu from '../../zujian/zidingyi/Qiehuandianpu.vue'
	import QiehuandianpuBianji from '../../zujian/zidingyi/QiehuandianpuBianji.vue'
	
	import Shangpitu from '../../zujian/zidingyi/Shangpitu.vue'
	import ShangpituBianji from '../../zujian/zidingyi/ShangpituBianji.vue'
	import Gerenzhongxin from '../../zujian/zidingyi/Gerenzhongxin.vue'
	import GerenzhongxinBianji from '../../zujian/zidingyi/GerenzhongxinBianji.vue'
	import Xinzengyemian from '../../zujian/zidingyi/Xinzengyemian.vue'
	import Jianzhi from '../../zujian/zidingyi/Jianzhi.vue'
	import JianzhiBianji from '../../zujian/zidingyi/JianzhiBianji.vue'
	import Shangjiatuijie from '../../zujian/zidingyi/Shangjiatuijie.vue'
	import ShangjiatuijieBianji from '../../zujian/zidingyi/ShangjiatuijieBianji.vue'
	import Miaosha from '../../zujian/zidingyi/Miaosha.vue'
	import draggable from "vuedraggable";
	export default {
		data() {
			return {
				zujian: [{
						tu: 'tb-wenben',
						ming: '文本',
						zuoyou: 'zuo',
						leixing: 'Wenzi'
					},
					{
						tu: 'tb-tupian',
						ming: '图片',
						zuoyou: 'zuo',
						leixing: 'Tu'
					},
					{
						tu: 'tb-anniu',
						ming: '按钮',
						zuoyou: 'zuo',
						leixing: 'Anniu'
					},
					{
						tu: 'tb-biaoti',
						ming: '标题',
						zuoyou: 'zuo',
						leixing: 'Biaoti'
					},
					{
						tu: 'tb-gaojiliebiao1',
						ming: '列表',
						zuoyou: 'zuo',
						leixing: 'Liebiao'
					},
					{
						tu: 'tb-shipin',
						ming: '视频',
						zuoyou: 'zuo',
						leixing: 'Shipin'
					},
					{
						tu: 'tb-lunbotu',
						ming: '轮廓',
						zuoyou: 'zuo',
						leixing: 'Lunkuo'
					},
					{
						tu: 'tb-gonggao',
						ming: '公告',
						zuoyou: 'zuo',
						leixing: 'Gonggao'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '添加组合',
						zuoyou: 'zuo',
						leixing: 'Zuhe'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '分类',
						zuoyou: 'zuo',
						leixing: 'Fenlei'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '轮播',
						zuoyou: 'zuo',
						leixing: 'Lunbo'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '商品列',
						zuoyou: 'zuo',
						leixing: 'Shangpin'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '搜索',
						zuoyou: 'zuo',
						leixing: 'Sousuo'
					},

					{
						tu: 'tb-tianjiazuhe',
						ming: '订单信息',
						zuoyou: 'zuo',
						leixing: 'Dingdan'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '常用服务',
						zuoyou: 'zuo',
						leixing: 'Fuwulie'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '资金信息',
						zuoyou: 'zuo',
						leixing: 'Zijin'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '切换店铺',
						zuoyou: 'zuo',
						leixing: 'Qiehuandianpu'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '商品图',
						zuoyou: 'zuo',
						leixing: 'Shangpitu'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '个人信息',
						zuoyou: 'zuo',
						leixing: 'Gerenzhongxin'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '兼职',
						zuoyou: 'zuo',
						leixing: 'Jianzhi'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '商家推介',
						zuoyou: 'zuo',
						leixing: 'Shangjiatuijie'
					},
					{
						tu: 'tb-tianjiazuhe',
						ming: '秒杀',
						zuoyou: 'zuo',
						leixing: 'Miaosha'
					},
				],
				zujian2: [{
						tu: 'tb-shuanglan',
						ming: '双栏',
						zuoyou: 'you'
					},
					{
						tu: 'tb-fengexian',
						ming: '分割线',
						zuoyou: 'you'
					},
					{
						tu: 'tb-danchuang',
						ming: '弹窗',
						zuoyou: 'you'
					},
					{
						tu: 'tb-mianban',
						ming: '面板',
						zuoyou: 'you'
					},
					{
						tu: 'tb-ziyoumianban',
						ming: '自由面板',
						zuoyou: 'you'
					},
					{
						tu: 'tb-huadongmianban',
						ming: '滑动面板',
						zuoyou: 'you'
					},
					{
						tu: 'tb-dongtaifenlei',
						ming: '动态分类',
						zuoyou: 'you'
					},
					{
						tu: 'tb-cebianlan',
						ming: '侧边栏',
						zuoyou: 'you'
					},
					{
						tu: 'tb-piaofuchuang',
						name: '悬浮窗',
						zuoyou: 'you'
					}
				],
				zujian3: [{
						tu: 'tb-duoshangjia',
						name: '多商家'
					},
					{
						tu: 'tb-liansuoduoshangjia',
						name: '连锁多商家'
					},
					{
						tu: 'tb-pintuan',
						name: '拼团'
					},
					{
						tu: 'tb-jichu',
						name: '基础'
					},
					{
						tu: 'tb-daodian',
						name: '到店'
					},
					{
						tu: 'tb-yuyue',
						name: '预约'
					},
					{
						tu: 'tb-paihao',
						name: '排号'
					},
					{
						tu: 'tb-zixun',
						name: '咨询'
					},
					{
						tu: 'tb-shequ',
						name: '社区'
					},
					{
						tu: 'tb-pinglun',
						name: '评论'
					},
					{
						tu: 'tb-dongtailiebiao',
						name: '动态列表'
					},
					{
						tu: 'tb-biaodan',
						name: '表单'
					},
					{
						tu: 'tb-dongtairongqi',
						name: '动态容器'
					},
					{
						tu: 'tb-shequtuangou',
						name: '社区团购'
					},
					{
						tu: 'tb-yushoudaojishi',
						name: '预售'
					}
				],
				zujian4: [{
						tu: 'tubiao tb-miaosha',
						name: '秒杀'
					},
					{
						tu: 'tb-meiriqiandao',
						name: '每日签到'
					},
					{
						tu: 'tb-youhuiquan',
						name: '优惠券'
					},
					{
						tu: 'tb-huiyuanka',
						name: '会员卡'
					},
					{
						tu: 'tb-chuzhi',
						name: '储值'
					},
					{
						tu: 'tb-dangmianfu',
						name: '当面付'
					},
					{
						tu: ' tb-zhuanpan',
						name: '大转盘'
					},
					{
						tu: ' tb-guaguale',
						name: '刮刮乐'
					},
					{
						tu: 'tb-zajindan ',
						name: '砸金蛋'
					},
					{
						tu: 'tb-jifen ',
						name: '积分商城'
					},
					{
						tu: 'tb-chuzhixiang',
						name: '储值项'
					}
				],		
				shu: [],
				lie: [],
				so: {
					ye: 1,
					jitiao: 20
				},
				oldleftlist: [],
				yidong_i: 0,
				bianji_shu: [],
				xinzengyemian_ming: '',
				yemian_shu: {},
				shan:false,
				yeming:[]
			}
		},
		components: {
			Shangtu,
			draggable,
			Wenzi,
			WenziBianji,
			Tu,
			TuBianji,
			Anniu,
			AnniuBianji,
			Biaoti,
			Liebiao,
			Shipin,
			Lunkuo,
			Gonggao,
			Zuhe,
			Lunbo,
			Fenlei,
			Shangpin,
			Sousuo,
			Dingdan,
			Fuwulie,
			Zijin,
			Qiehuandianpu,ShangpituBianji,Shangpitu,
			Gerenzhongxin,
			BiaotiBianji,
			LiebiaoBianji,
			ShipinBianji,
			LunkuoBianji,
			GonggaoBianji,
			ZuheBianji,
			LunboBianji,
			FenleiBianji,
			ShangpinBianji,
			SousuoBianji,
			DingdanBianji,
			FuwulieBianji,
			ZijinBianji,
			QiehuandianpuBianji,
			GerenzhongxinBianji,
			Xinzengyemian,
			Jianzhi,
			JianzhiBianji,
			Shangjiatuijie,
			ShangjiatuijieBianji,
			Miaosha
			// MiaoshaBianji
		},
		computed: {
			dragOptions1() {
				return {
					animation: 0,
					group: {
						name: "description",
						pull: 'clone'
					},
					ghostClass: "ghost",
				};
			},
			dragOptions2() {
				return {
					animation: 0,
					group: "description",
				};
			}

		},
		created() {
			that = this;
			that.CSH();
		},
		methods: {
			CSH() {
				this.$post('k=zidingyi', that.so, function(s) {
					that.lie = s.shu.lie;
					if (that.lie[0]) {
						that.Yemian(that.lie[0]);
						that.shu = that.lie[0].lishishuju;
					}
					// that.zongshu = Number(s.shu.zongshu);
				});
			},
			onMove(e) {
				const relatedElement = e.relatedContext.element;
				const draggedElement = e.draggedContext.element;
				if (draggedElement.zuoyou == 'zuo' && !relatedElement) {
					return true;
				} else {
					if ((relatedElement.zuoyou == 'you' && draggedElement.zuoyou == 'zuo') || (relatedElement.zuoyou == 'you' &&
							draggedElement.zuoyou == 'you')) {
						that.yidong_i = e.draggedContext.futureIndex;
						return ((!relatedElement || !relatedElement.fixed) && !draggedElement.fixed);
					} else {
						return false;
					}
				}


			},
			leftEnd() {
				if (that.yidong_i >= 0) {
					this.shu[that.yidong_i].zuoyou = 'you';
					this.shu = JSON.parse(JSON.stringify(this.shu));
				}

			},
			Bianji(e) {
				this.bianji_shu = {},
					this.bianji_shu = e;
				if (!this.bianji_shu.yangshi) {
					this.bianji_shu.yangshi = {};
				}
			},
			Yemian(e) {
				that.shu = e.lishishuju || [];
				that.yemian_shu = e;
				that.bianji_shu = {
					leixing: 'Xinzengyemian'
				};

			},
			Xinzengyemian() {
				this.$post('k=zidingyi&c=xinzeng', {
					biaoti: this.xinzengyemian_ming
				}, function(s) {
					that.$xiaoxi(s.shu)
					if (s.shi == 1) {
						that.CSH()
					}
				})
			},
			Tijiao(e) {
				this.yemian_shu.lishishuju = that.shu;
				if (e) {
					this.yemian_shu.shu = that.shu;
				}
				this.$post('k=zidingyi&c=Xiugai', this.yemian_shu, function(s) {
					that.$xiaoxi(s.shu)
				})
			},
			Shanchu(e) {
				if (this.shu.length == 1) {
					that.$xiaoxi("不能为空");
				} else {
					this.shu.splice(e, 1);
					that.bianji_shu = {};
				}

			},
			Shanchu2(e,id){
				if (this.lie.length == 1) {
					that.$xiaoxi("不能为空");
				} else {
					that.$post('k=zidingyi&c=shanchu',{id:id},function(s){
						that.$xiaoxi(s.shu);
						if(s.shi){
							that.lie.splice(e,1)
							that.yeming = {};
						}
						
					});
					
					
				}
			}
		},
	}
</script>

<style>	

	.left_box,.right_box{
		min-width: 285px;
		width: 16%;
	}
	.zidingyi_hezi .el-scrollbar__wrap {
		overflow-x: hidden;
		height: 520px;
	}
	.right_neirong .el-scrollbar__wrap {
		overflow-x: hidden;
		height:90vh;
	
	}
	.right_neirong .el-scrollbar__view {
	
		margin-bottom: 30px;
	}
	.box {
		width: 100%;
		min-width: 1229px;
		display: flex;
		overflow: hidden;
		height: 100vh;
	}

	.el-tabs__header {
		margin: 0;
	}

	.el-tabs__item {
		/* width:68%;
		height: 60px;
		padding-top: 10px; */
	}

	.el-tabs__item {
		/* background: #FFFFFF; */
		border-bottom: 1px solid #CCCCCC;
	}


	
	.yemianlie  .el-scrollbar__wrap {
		overflow-x: hidden;
		height:80vh;
		padding-bottom: 17px;
		background: #FFF;
	}
  
  
	.el-icon-document-remove {
		margin-left: 20px;
	}

	.tianjiafenzu {
		/* width: 100%; */
		background: #FFFFFF;
		padding: 16px 6px;
		border-bottom: 1px solid #CCCCCC;
		cursor: pointer;
		font-size: 14px;
	}

	.el-icon-folder-opened {
		margin: 0 6px;
	}

	.fenzus {
		padding: 10px 40px;
		border-bottom: 1px solid #E4E7ED;
		color: #6a728a;
		font-size: 14px;
		cursor: pointer;
		margin: 0px 10px;
	}

	.tijiayemian {
		margin: 8px;

		text-align: center;
		background: #f6f6fb;
		color: #b6bbc7;

		font-size: 14px;
		cursor: pointer;
	}

	.el-icon-document-add {
		margin-right: 10px;
	}

	.el-tabs__item {
		height: 60px;
		/* padding: 0 17px !important; */
		padding-top: 10px;

	}

	.el-tabs__nav {
		margin-left: 15px !important;
	}

	.el-tabs__header {
		background: #FFFFFF;
	}

	.zujian_top {
		width: 100%;
		/* background: #008000; */
	}

	.zujian_top ul {
		display: flex;
		flex-wrap: wrap;
		width: 100%;

	}
    .zujian_top .el-scrollbar__wrap {
    	overflow-x: hidden;
    	height:80vh;
    	padding-bottom: 17px;
		
    }
	.zujian_top ul li {
		list-style: none;
		width: 25.6%;
		border: 1px solid #f3f3f3;
		padding: 18px 10px;
		text-align: center;
		background: #FFFFFF;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		font-size: 14px;
		color: #616e8c;
	}

	.zujian_top ul li span {
		display: block;
		width: 100%;
		font-size: 18px;
		padding-bottom: 10px;
	}

	.zujian_top ul li:hover {
		color: #409EFF;
	}

	.zujian_top ul li span:hover {
		color: #409EFF;
	}

	.zujian_xia {
		width: 100%;
	}

	.ul {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}

	.ul li {
		list-style: none;
		width: 25.6%;
		border: 1px solid #f3f3f3;
		padding: 20px 10px;
		text-align: center;
		background: #FFFFFF;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		cursor: pointer;
		font-size: 14px;
		color: #616e8c;
		position: relative;
	}

	.ul li span {
		display: block;
		width: 100%;
		font-size: 18px;
		padding-bottom: 10px;
	}

	.ul li:hover {
		color: #409EFF;
	}

	.erji {
		padding: 15px 0 15px 20px;
		background: #FFFFFF;
	}

	.zuhemuban {
		padding: 15px 0 15px 15px;
		background: #FFFFFF;
	}

	.el-icon-arrow-right {
		float: right;
		margin-right: 20px;
	}

	.el-icon-notebook-2 {
		margin-right: 10px;
	}

	/* 中间 */
	.neirong_box {
		width: 64%;
	}

	.neirong_tou {
		width: 100%;
		background: #FFFFFF;
		height: 60px;
		display: flex;
		justify-content: space-between;
	}

	.houytaianniu {
		/* width: 60px; */
		/* height: 46px;
		    margin-top: 6px;
		    margin-right: 10px; */
		height: 31px;
		line-height: 5px;
		margin-top: 12px;
		margin-right: 10px;
	}

	.neirong_shouji {
		width: 100%;
		height: 100%;
		background: #e6e6ee;
		/* padding: 70px 0 0 0; */
		/* position: relative; */
	}

	.neirong_shoujiqu {
		width: 320px;
		height: 568px;
		border: 1px solid #b8b8ba;
		/* margin: 0 auto; */
		/* padding-top: 76px; */
		position: absolute;
		top: 76px;
		left: 50%;
		margin-left: -160px;
		background: #FFFFFF;
		border-radius: 5px;

	}

	.shouji_tou {
		padding: 14px;
		border-bottom: 1px solid #dddddd;
		display: flex;
		justify-content: space-between;
	}

	.tou_biaoti {
		margin-left: 40px;
	}

	.tou_rigth {
		width: 70px;
		height: 24px;
		border: 1px solid #dddddd;
		border-radius: 15px;
		display: flex;
		justify-content: center;
	}

	.tu {
		margin-top: 4px;
	}

	.tianjiazuhe,
	.neirong_shoujiqu .sortable-chosen {
		/* margin: 8px; */
		/* padding: 10px; */
		text-align: center;
		color: #b6bbc7;
		/* border: 1px dashed #CCCCCC; */
		font-size: 14px;
		cursor: pointer;
	}

	.tianjiazuhe {
		position: relative;
	}

	.anniu {
		width: 30px;
		position: absolute;
	}

	.zuoshang {
		left: 32%;
	}

	.zuoxia {
		top: 60px;
		left: 32%;
	}

	.anniu_zuo {
		width: 60px;
		position: absolute;
		left: 74px;
		top: 125px;
	}

	.youxia {
		left: 32%;
		top: 420px;
	}

	.anniu_you {
		width: 60px;
		position: absolute;
		right: 82px;
		top: 125px;
	}

	.liangchi {
		margin-top: 20px;
		margin-left: 20px;
		display: flex;
		color: #5b627d;
	}

	.jiajian {
		margin-left: 10px;
		color: #5b627d;
	}

	.ye_ming {
		margin-top: 20px;
		font-size: 15px;
		color: #5b627d;
	}

	.shouji_box {
		position: relative;
		margin: 0 auto;
		width: 600px;
		height: 600px;
	}

	.qianjin {
		display: block;
		font-size: 12px;
		color: #9599ad;
		width: 100%;
		text-align: center;
	}

	.houtui {
		display: block;
		font-size: 12px;
		color: #9599ad;
		width: 100%;
		text-align: center;
	}

	.shoujiyou_tu {
		display: block;
		font-size: 12px;
		color: #9599ad;
		width: 100%;
		text-align: center;
	}

	/*头部 图标 */
	.tb-lower-triangle {
		margin-top: 4px;
		color: #C0C0C0;
		margin-left: 6px;
	}

	.tb-tubiao- {
		color: #CCCCCC;
		margin-right: 6px;
	}

	.el-icon-minus {
		margin-right: 4px;
		cursor: pointer;
	}

	.el-icon-plus {
		margin-left: 4px;
		cursor: pointer;
	}

	/* 右边 */
	.right_box {
		width: 20%;
	}

	.right_tou {
		width: 96%;
		height: 46px;
		background: #FFFFFF;
		padding: 7px;
		display: flex;
		justify-content: space-between;
	}

	.small {
		padding: 0px 40px;
		height: 30px;
		margin-top: 6px;
	}

	.xialakuang {
		/* text-indent: 25px; */
		background: #e6e6ee;
		text-indent: 10px
	}

	.el-collapse-item__header {
		background: #eeeef3;
	}

	.el-collapse-item__content {
		background: #f2f4f8;
		padding: 10px;
	}

	/* .zujianlei{
		width:66px;
		height: 66px;
		background: #FFFFFF;
	} */
	.zujianul {
		width: 100%;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	}

	.zujianul li {
		list-style: none;
		width: 22%;
		display: flex;
		flex-wrap: wrap;
		cursor: pointer;
	}

	.zujian {
		display: flex;
		justify-content: space-between;
	}

	.beijin {
		width: 50px;
		background: #acacc1;
		color: #FFFFFF;
		font-size: 12px;
		text-align: center;
		float: left;
		padding-right: 10px;
	}

	.tu_zujianming {
		text-align: center;
		display: block;
		width: 100%;
	}

	.i {
		font-size: 64px;
		color: #CCCCCC;
		margin-left: -12px;
		/* margin-top: 4px; */
	}

	.i2 {
		font-size: 34px;
		color: #CCCCCC;
		margin-left: 4px;
		margin-top: 16px;
	}

	.zujian_tu {
		background: #FFFFFF;
		width: 100%;
		height: 66px;
	}

	.el-tabs__nav-scroll {
		/* overflow: hidden; */
		border-top: 1px solid #cccccc;
	}

	.toumingdu {
		display: flex;
		justify-content: center;
	}

	.huadong {
		width: 40%;
		margin-left: 14px;
	}

	.biganniu {
		width: 100%;
		margin-left: -10px;
	}

	/* 正式代码 */
	.zujian_ul {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		min-height: 150px;
		/* justify-content: space-between; */

	}

	.zujian_ul div {
		width: 25.6%;
		cursor: pointer;
		text-align: center;
		font-size: 14px;
		border: 1px solid #f3f3f3;
		padding: 20px 10px;
		background: #FFFFFF;
		color: #616e8c;
	}
    .zujian_ul div p{padding: 0;margin: 0;}
	.zujian_ul div .Tubiao {
		font-size: 30px;
	}

	.neirong_shoujiqu .sortable-chosen {
		border: 1px solid orangered;
		color: orangered;
	}

	.tianjiazuhe_Shanchu , .tianjiazuhe_Shanchu2{
		position: absolute;
		right: 0;
		top:10px;
		display: none;
		z-index: 999;
	}
	
	.tianjiazuhe:hover .tianjiazuhe_Shanchu {
		display: block;
	}
	.fenzus:hover .tianjiazuhe_Shanchu2 {
		display: block;
		font-size: 18px;
	}
	.neirong_shouji .el-scrollbar__view{
		margin-bottom: 100px;
	}
	.tianjiazuhe Shangpin{
		margin-top: 20upx;
	}
</style>
